module.exports = __webpack_public_path__ + "assets/img/home_banner1_right.cbe28b4e.png";